export default "__VITE_ASSET__xXdbLtgt__"